export default "__VITE_ASSET__Cz7dfSYs__"